const outlineOffset = {
  name: "outline-offset",
  path: "/outline-offset",
  title: "outline-offset",
  description: "Utilities for controlling the offset of an element's outline.",
  value: {
    'outline-offset': {
      'outline-offset-<number>': '<number>px;',
      '-outline-offset-<number>': 'calc(<number>px * -1);',
      'outline-offset-[<value>]': '<value>;',
    },
  },
  exampleData: [
    {
      example: {
        code: `<button class="outline-2 outline-offset-2 outline-color-blue-500 px-4 py-2">offset 2px</button>
<button class="outline-2 outline-offset-4 outline-color-blue-500 px-4 py-2">offset 4px</button>
<button class="outline-2 -outline-offset-4 outline-color-blue-500 px-4 py-2">offset -2px</button>
<button class="outline-2 outline-offset-[10px] outline-color-blue-500 px-4 py-2">offset 10px</button>
`
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">outline-offset-2</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">outline-offset-4</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">-outline-offset-2</code>, and <code class="text-color-gray-800 dark:text-color-white font-semibold">outline-offset-[10px]</code> to set the outline offset of an element.
      </p>
      <div class="flex justify-center gap-6 items-center text-sm flex-wrap text-color-gray-500">
          <button class="outline-2 outline-offset-2 outline-color-red-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button A</button>
          <button class="outline-2 outline-offset-4 outline-color-blue-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button B</button>
          <button class="outline-2 -outline-offset-4 outline-color-orange-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button C</button>
          <button class="outline-2 outline-offset-[10px] outline-color-green-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button D</button>
      </div>
      `
    }
  ]
};

export default outlineOffset;

<div class="sr-only flex justify-center gap-6 items-center text-sm flex-wrap text-color-gray-500">
          <button class="outline-2 outline-offset-2 outline-color-red-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button A</button>
          <button class="outline-2 outline-offset-4 outline-color-blue-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button B</button>
          <button class="outline-2 -outline-offset-4 outline-color-orange-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button C</button>
          <button class="outline-2 outline-offset-[10px] outline-color-green-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button D</button>
      </div>